// extracted by mini-css-extract-plugin
export var collapsedSummary = "_ly-0";